export enum SkillRelatedData {
  courses = "courses",
  skill_category = "skill_category",
  industry = "industry",
  universities = "universities",
  jobs = "jobs",
  UAE_States = "UAE_States"
}

const skills_data: SkillsData = {
  [SkillRelatedData.courses]: [
    "Bachelor of Science in Information Systems",
    "Bachelor of Science in Computer Engineering",
    "BACHELOR OF PHARMACY (BPharm)",
    "MSc In Water And Environmental Engineering",
    "MSC NETWORK MANAGEMENT AND CLOUD COMPUTING",
    "Master of Science in Pharmaceutical Sciences",
    "Bachelor of Science in Networks and Communication Engineering",
    "Bachelor of Science in Software Engineering",
    "General Business Minor",
    "MSc In Cyber Security",
    "Master of Science in Information Systems Management",
    "MBA in Human Resources Management",
    "Bachelor of Information Systems",
    "Information Technology",
    "Bachelor Logistics Engineering Technology",
    "Marketing",
    "Bachelor of Science in Civil Engineering",
    "Bachelor of Science in Cybersecurity",
    "Bachelor of Science in Marketing",
    "Master of Science in Artificial Intelligence",
    "Bachelor of Computer Science (Game and Mobile Development)",
    "Bachelor of Business Administration",
    "MSc In Electrical And Computer Engineering",
    "Bachelor of Science in Communication Engineering",
    "Bachelor of Science in Computer Engineering",
    "Bachelor of Finance and Banking",
    "Master of Science in Clinical Pharmacy (MSc in Clinical Pharmacy)",
    "MSc In Computational Data Science",
    "Bachelor of Science in Computer Science",
    "MBA in Financial Management",
    "Master of Science in Clinical Pharmacy",
    "Bachelor of Science in Computer Engineering",
    "BBA in Management",
    "Master of Business Administration",
    "Human Resource Management",
    "Business Analytics",
    "MSC APPLIED PSYCHOLOGY",
    "Computer Science MSE",
    "Electrical and Computer Engineering"
  ],
  [SkillRelatedData.skill_category]: [
    { text: "Domain Specific Skills", value: "Domain Specific Skills" },
    {
      text: "Soft Skills",
      value: "Soft"
    },
    {
      text: "Leadership and Management",
      value: "Leadership and Management"
    },
    {
      text: "IT and Software",
      value: "IT and Software"
    },
    {
      text: "Hard skills",
      value: "Hard"
    },
    {
      text: "Green Skills",
      value: "Green"
    }
  ],
  [SkillRelatedData.industry]: [
    "Tourism and Accommodation Service",
    "Food Production, Manufacturing and Service",
    "Transport, Tourism and Accommodation Service",
    "Tourism and Accommodation Service",
    "Retail",
    "Tourism and Accommodation Service",
    "Food Production, Manufacturing and Service",
    "Marine and Offshore",
    "Food Production, Manufacturing and Service",
    "Housing and Construction",
    "Healthcare",
    "Housing and Construction",
    "Food Production, Manufacturing and Service",
    "Retail",
    "Information and Communication Technologies (ICT)",
    "Media",
    "Retail",
    "Financial Service",
    "Financial Service",
    "Information and Communication Technologies (ICT)",
    "Food Production, Manufacturing and Service",
    "Food Production, Manufacturing and Service",
    "Information and Communication Technologies (ICT)",
    "Tourism and Accommodation Service",
    "Logistic",
    "Food Production, Manufacturing and Service"
  ],
  [SkillRelatedData.universities]: [
    "Middlesex University Dubai",
    "Zayed University",
    "Ajman University",
    "Gulf Medical University",
    "Khalifa University",
    "Higher Colleges of Technology",
    "Al Ain University",
    "University of Wollongong in Dubai",
    "UAE University",
    "Princeton University",
    "University of Sharjah"
  ],
  [SkillRelatedData.jobs]: [
    "Role in Guest Services.",
    "Role in Food and Beverage.",
    "Bellman.",
    "Guest Services Executive - Front Office - Jumeirah Zabeel Saray.",
    "Customer Service Officer.",
    "Role in Front Office.",
    "Brand Manager.",
    "Office Manger (Dubai - DIFC).",
    "Food Safety Supervisor.",
    "Real Estate Sales Consultant.",
    "General Manager.",
    "FM - Engineer.",
    "Commis I (Hot Section).",
    "Store Manager.",
    "Graphic Designer.",
    "Receptionist.",
    "Store Manager.",
    "Business Development Executive - Skiply Portfolio Management.",
    "Retail Banking Officer - Multiproduct.",
    "MARKETING AND E-COM. OFFICER.",
    "Marketing Manager.",
    "Research and Innovation Manager.",
    "Analytics Manager.",
    "Front Office Ambassador|Front Office (AFR).",
    "Storekeeper.",
    "Senior Accounting Officer.",
    "Financial Control Analyst - Finance.",
    "Food & Beverage Attendant."
  ],
  [SkillRelatedData.UAE_States]: [
    { text: "Abu Dhabi", img: "/cities/AbuDhabi.png", value: "Abu Dhabi" },
    { text: "Dubai", img: "/cities/Dubai.png", value: "Dubai" },
    { text: "Sharjah", img: "/cities/Sharjah.png", value: "Sharjah" },
    { text: "Ajman", img: "/cities/Ajman.png", value: "Ajman" },
    {
      text: "Umm Al Quwain",
      img: "/cities/UmmAlQuwain.png",
      value: "Umm Al Quwain"
    },
    {
      text: "Ras Al Khaimah",
      img: "/cities/RasAlKhaimah.png",
      value: "Ras Al Khaimah"
    },
    { text: "Fujairah", img: "/cities/Fujairah.png", value: "Fujairah" }
  ]
};

export function get_skill_related_data(skill: string): any {
  return skills_data[skill];
}

type SkillsData = {
  [key: string]: any;
  courses: string[];
  skill_category: { text: string; value: string }[];
  industry: string[];
  universities: string[];
  jobs: string[];
  UAE_States: { text: string; img: string; value: string }[];
};
